import type { CosignatureSupervisorsResponse } from "@/core/types";
import { permissionsRequestsTyped } from "@/api/(requests)/permissionsTyped";

export async function getCosignatureSupervisors(): Promise<CosignatureSupervisorsResponse> {
  return permissionsRequestsTyped.get_cosign_supervisors();
}
